import { ChevronDownIcon, Menu, Pressable, HStack } from 'native-base';
import { useTranslation } from 'react-i18next';

import { Text } from '@pimm/base';
import type { ExportScope } from '../types';

type ExportButtonProps = {
  icon: React.ReactElement;
  label: string;
  onSelect: (scope: ExportScope) => void;
};

export const ExportButton = ({ icon, label, onSelect }: ExportButtonProps) => {
  const { t } = useTranslation();

  const handleSelect = (scope: ExportScope) => () => onSelect(scope);

  return (
    <Menu
      placement="bottom right"
      shadow="5"
      bg="white"
      rounded="lg"
      trigger={triggerProps => (
        <Pressable
          {...triggerProps}
          rounded="lg"
          px={3}
          h={9}
          shadow={1}
          justifyContent="center"
          borderWidth={1}
          borderColor="gray.300"
          bg="white"
          _hover={{ borderColor: 'gray.400' }}
          _pressed={{ opacity: 0.8 }}
          _focus={{ bg: 'white' }}
        >
          <HStack space={1.5} alignItems="center">
            {icon}
            <Text size="sm" fontWeight={500} color="gray.700">
              {label}
            </Text>
            <ChevronDownIcon size={3} color="gray.500" />
          </HStack>
        </Pressable>
      )}
    >
      <Menu.Item py={3} _focus={{ bg: 'white' }} onPress={handleSelect('current')}>
        <Text size="md" fontWeight={600} color="gray.700">
          {t('store_equipment:current_view')}
        </Text>
      </Menu.Item>
      <Menu.Item py={3} _focus={{ bg: 'white' }} onPress={handleSelect('full')}>
        <Text size="md" fontWeight={600} color="gray.700">
          {t('store_equipment:full_report')}
        </Text>
      </Menu.Item>
    </Menu>
  );
};
